import React from 'react';
import { Icon } from './Icon.js';
export const IconClipboard = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("rect", { x: "4", y: "4", width: "12", height: "13", rx: "3", ry: "3", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }),
        React.createElement("rect", { x: "8", y: "3", width: "4", height: "2", rx: ".25", ry: ".25", fill: "currentColor", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" })));
};
//# sourceMappingURL=IconClipboard.js.map